export default {
    setResetPass(state, new_password) {
        for (let field in state.data) {
            state.data[field] = new_password[field];
        }
    },
    loadingResetPass(state) {
        state.loading = true;
    },
    successResetPass(state) {
        state.loading = false;
        state.success = true;
        state.error = false;
    },
    errorResetPass(state, error) {
        state.loading = false;
        state.success = false;
        state.error = error;
    },
    resetSuccessResetPass(state) {
        state.success = false;
        state.data.password = '';
        state.data.new_password = '';
    },
};
